// Form.js
import React, { useState } from 'react';
import { Container, TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl, Typography } from '@mui/material';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import IconButton from '@mui/material/IconButton';
import ModalAlert from './modal';


const Form = () => {
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const showAlert = (message) => {
    setModalMessage(message);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setModalMessage('');
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('id', id);

    try {
      const response = await axios.post('http://13.124.203.56/sungpt/delete_user.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('Server response:', response.data);

      const count = response.data.count;

      showAlert("삭제되었습니다.");
      setTimeout(() => {
        navigate('/sungpt'); // 이동할 페이지의 상대 경로
      }, 700); // 1초 후 이동

    } catch (error) {

      console.error('There was an error uploading the form!', error);
    }
  };

  function generateRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


const a = generateRandomNumber(10, 100).toString();
const b = generateRandomNumber(10, 100).toString();

  const buttonmake = () => {
    showAlert("추천인 코드는 " + a + id + b + "입니다." );
  };

  return (
    <Container component="main" maxWidth="xs"
      sx={{mt: 4}}>
      <div>
        <form onSubmit={handleSubmit} noValidate>

        <div style={{
          display: 'flex',
          alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'}}>

                <IconButton onClick={() => navigate('/')} color="primary">
                  <HomeOutlinedIcon sx={{ color: 'black', fontSize: '2.5rem' }} />
                </IconButton>


          <Typography variant="h5" gutterBottom sx={{mt:8, mb:4, textAlign: 'center'}}>
            현재 매칭 대기 중입니다.
          </Typography>

        </div>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 30, mb: 2 }}
            sx={{height:'50px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
          >
            신청 정보 삭제
          </Button>

          <Button
            type="button" onClick={buttonmake}
            fullWidth
            variant="contained"
            color="primary"
            sx={{mt:4, height:'50px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
          >
            추천인 코드 만들기
          </Button>

        </form>



      </div>


    </Container>
  );
};

export default Form;
